const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const BadWord = () => import(/* webpackChunkName: "badword" */ './view/edit.vue');

export const ROUTE_NAME_BADWORD = 'Badword' as const;

export default [
    {
        path: '/app/:appId/badword',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_BADWORD,
                component: BadWord,
                meta: { requiresAuth: true }
            }
        ]
    }
];
